import { CellCoordsObj } from '../../../../../../../common/table/TableTypes';
import { getSharedCellTypeFormatOptions } from '../../dataUtils/cell/tableCellTypeModelUtils';
import { getHotTableCellData } from '../meta/hotTableCellMetaUtils';
import type { MNHotInstance } from '../../../tableHotInstanceTypes';

/**
 * Returns the shared formatting state for the current HoT selection.
 */
export const getSharedCellTypeFormatOptionsFromHot = (
    hotInstance: MNHotInstance | null | undefined,
    allSelectedCells: Array<CellCoordsObj>,
) => {
    if (!hotInstance || !allSelectedCells || allSelectedCells.length === 0) return;

    const selectedCellsTypes = allSelectedCells.map(
        ({ row, col }) => getHotTableCellData(hotInstance, { row, col })?.type,
    );

    return getSharedCellTypeFormatOptions(selectedCellsTypes);
};
